import { QueryOptionsType, Product } from "@framework/types";
import http from "@framework/utils/http";
import { API_ENDPOINTS } from "@framework/utils/api-endpoints";
import { useQuery } from "react-query";
export const fetchSearchedProducts = async ({
  queryKey
}: any) => {
  const [_key, _params] = queryKey;
  const searchQuery = _params?.text ? `${encodeURIComponent(_params.text)}` : "";
  const {
    data
  } = await http.get(`${API_ENDPOINTS.SEARCH}${searchQuery}`);
  return data.results || [];
};
export const useSearchQuery = (options: QueryOptionsType) => {
  return useQuery<Product[], Error>([API_ENDPOINTS.SEARCH, options], fetchSearchedProducts, {
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  });
};